module.exports = "/_next/static/images/rebranding-d7317912085ebb16616688d03ba2e317.svg";